function Stepper(el) {

    var self = this;

    this.btnUp = el.querySelector('.stepper__button--increment');
    this.btnDown = el.querySelector('.stepper__button--decrement');
    this.quantity = el.querySelector('.stepper__quantity');
    this.step = isNaN(parseInt(el.dataset.step)) ? 1 : el.dataset.step;

    this.keys = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57] // 0-9

    // Public functions
    this.init = init;

    // Set up a stepper
    function init() {
        this.btnUp.onclick = this.increment.bind(this);
        this.btnDown.onclick = this.decrement.bind(this);
        this.quantity.onfocus = this.checkInput.bind(this);
        this.quantity.onblur = this.checkValue.bind(this);
    }

    this.increment = function (e) {
        e.preventDefault();
        var qty = parseInt(this.quantity.value) + parseInt(this.step);
        this.quantity.value = qty;   
        
    }

    this.decrement = function (e) {
        e.preventDefault();
        var qty = parseInt(this.quantity.value) - parseInt(this.step);
        qty = (qty < 0) ? 0 : qty;
        this.quantity.value = qty;   
    }

    this.checkInput = function(e) {
        this.quantity.onkeypress = function(e) {
            var currentVal = self.quantity.value;
            if (self.keys.indexOf(e.charCode) == -1) {
                return;
            }
        }
    }

    this.checkValue = function (e) {
        var qty = this.quantity.value
        if (qty < 0 ) {
            this.quantity.value = 0;
            return;
        }

        if (qty % this.step != 0) {
            this.quantity.value = Math.round(parseInt(qty)/parseInt(this.step)) * parseInt(this.step);
            return;
        }
    }
}
